import { Expose } from "class-transformer";

export class CreateReportTemplateDto {
  @Expose()
  name: string;

  @Expose()
  interventionId: string;

  @Expose()
  clientGroupId: string;
}
